import React, { useState, useEffect } from "react";
import { Avatar, Stack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const componentsOrder = [
  "AC Wire",
  "DC Wire",
  "Protection Box",
  "Earthing System",
  "Mounting Structure",
  "PVC Works",
  "Additional Requirements",
];

export default function PriceDetail() {
  const location = useLocation();
  const [priceList, setPriceList] = useState();

  useEffect(() => {
    if (location.state) {
      const { item } = location.state;
      setPriceList(item);
    }
  }, [location.state]);
console.log("Price List:", priceList);
  return (
    <>
      <div style={{
        maxHeight: "80vh", width: "100%", position: "relative", overflowY: "scroll", overflowX: 'hidden', scrollbarColor: '#A0AEC0 #EDF2F7',
        scrollbarWidth: '10px'
      }}>
        <div className=" card mt-4 mobile-margin mb-2">
          <div
            className="d-flex justify-content-between "
            style={{ marginLeft: "14px" }}
          >
            <div className="col-lg-2  col-md-2 col-3 mt-3 mb-3">
              <Stack direction="row">
                <Avatar
                  size="xl"
                  // name="Christian Nwamba"
                  name={priceList?.brand?.solarBrandName}
                  src="https://bit.ly/code-beast"
                  boxSize={{ base: "80px", xl: "100px" }}
                />
              </Stack>
            </div>
            <div className="col-lg-6 col-md-3 col-7 mt-4  priceName">
              <h4 style={{ color: "#023233" }}>
                {priceList?.brand?.solarBrandName}
              </h4>
              <p>{priceList?.solar?.panelName}</p>
            </div>
            <div className="col-lg-4 col-md-7  col-2 mt-3 "></div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-6 col-md-12  align-items-stretch">
            <div className="card card-detail p-0 rounded">
              <div className="card-body py-0 pe-0">
                <div className="table-responsive table-div1">
                  <table className="table table-space ">
                    <tr>
                      <th className="font-weight table-space">
                        {" "}
                        Solar Panel Name
                      </th>
                      <td className="font-color">
                        {priceList?.brand?.solarBrandName}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12  align-items-stretch">
            <div className="card card-detail p-0 rounded">
              <div className="card-body py-0 pe-0">
                <div className="table-responsive table-div1">
                  <table className="table table-space">
                    <tr>
                      <th className="font-weight table-space">
                        Inverter Brand
                      </th>
                      <td className="font-color">
                        {priceList?.solar?.panelName}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="accordion-item border rounded mt-2 ">
          <h5
            data-bs-toggle="collapse"
            data-bs-target="#collapseInvoices"
            aria-expanded="true"
            aria-controls="collapseInvoices"
            className="px-2 d-flex align-items-center bg-light mb-0 gap-1"
            style={{ height: "40px" }}
          >
            <ChevronDown color="#ff176b" strokeWidth="1" size="25" />
            <button
              style={{ fontSize: "14px" }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseInvoices"
              aria-expanded="true"
              aria-controls="collapseInvoices"
            >
              <p
                className="my-0"
                style={{ color: "#26d155", fontSize: "17px" }}
              >
                1ph Monoperc 540-550Wp
              </p>
            </button>
          </h5>
          <div
            id="collapseInvoices"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="custom-scroll" style={{ maxHeight: "60vh" }}>
                <div className="row">
                  <div className="col-lg-12 col-md-12  align-items-stretch">
                    <div className="card card-detail p-0">
                      <div className="card-body py-0">
                        <div className="table-responsive table-div1 mt-2">
                          <table className="table table-space">
                            <thead>
                              <tr className="tr-border">
                                {[
                                  "No. of Panels",
                                  "Project kW",
                                  "Warranty (Years)",
                                  "Inverter Capacity",
                                  "Inverter Warranty",
                                  "Total Cost",
                                  "Subsidy Amount",
                                  "After Subsidy",
                                ].map((header) => (
                                  <th
                                    key={header}
                                    style={{
                                      border: "1px solid #dee2e6",
                                      backgroundColor: "#f8f9fa",
                                      padding: "8px",
                                    }}
                                  >
                                    {header}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {priceList?.solarPricingSpecificationsGrouped?.[
                                "1ph Monoperc 540-550Wp"
                              ]?.map((item, index) => (
                                <tr key={index} className="tr-border">
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.noOfPanels}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.projectKW}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.warranty}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.inverterCapacity}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.inverterWarranty}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.totalCost}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.subsidyAmount}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.afterSubsidy}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="accordion-item border rounded mt-2">
          <h5
            data-bs-toggle="collapse"
            data-bs-target="#collapseEstimates"
            aria-expanded="true"
            aria-controls="collapseEstimates"
            className="px-2 d-flex align-items-center bg-light mb-0 gap-1"
            style={{ height: "40px" }}
          >
            <ChevronDown color="#ff176b" strokeWidth="1" size="25" />
            <button
              style={{ fontSize: "14px" }}
              className=""
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEstimates"
              aria-expanded="true"
              aria-controls="collapseEstimates"
            >
              <p
                className="my-0"
                style={{ color: "#e5ab0a", fontSize: "17px" }}
              >
                {" "}
                3ph Topcon 575-595 Wp
              </p>
            </button>
          </h5>
          <div
            id="collapseEstimates"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="custom-scroll" style={{ maxHeight: "60vh" }}>
                <div className="row mt-2">
                  <div className="col-lg-12 col-md-12  align-items-stretch">
                    <div className="card card-detail p-0">
                      <div className="card-body py-0 pe-0">
                        <div className="table-responsive table-div1 mt-2">
                          <table className="table table-space">
                            <thead>
                              <tr className="tr-border">
                                {[
                                  "No. of Panels",
                                  "Project kW",
                                  "Warranty (Years)",
                                  "Inverter Capacity",
                                  "Inverter Warranty",
                                  "Total Cost",
                                  "Subsidy Amount",
                                  "After Subsidy",
                                ].map((header) => (
                                  <th
                                    key={header}
                                    style={{
                                      border: "1px solid #dee2e6",
                                      backgroundColor: "#f8f9fa",
                                      padding: "8px",
                                    }}
                                  >
                                    {header}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {priceList?.solarPricingSpecificationsGrouped?.[
                                "3ph Topcon 575-595 Wp"
                              ]?.map((item, index) => (
                                <tr key={index} className="tr-border">
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.noOfPanels}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.projectKW}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.warranty}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.inverterCapacity}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.inverterWarranty}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.totalCost}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.subsidyAmount}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #dee2e6",
                                      padding: "8px",
                                    }}
                                  >
                                    {item.afterSubsidy}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-6 col-md-12  align-items-stretch">
            <div className="card card-detail p-0">
              <div className="card-body py-0 pe-0">
                <div className="table-responsive table-div1">
                  <table className="table table-space">
                    <tbody>
                      {componentsOrder.map((component, idx) => {
                        const detail = priceList?.priceComponentDetailsResponse?.[idx];
                        return (
                          <tr className="tr-border" key={component}>
                            <th className="font-weight table-space p-2">
                              {component}
                            </th>
                            <td className="font-color">
                              {detail?.description || ""}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
